
<strong class="cmp-premium-badge ws-typography">
  <ws-icon name="favourite" :size="16" />
  <small v-if="!iconOnly" class="badge-label">
    <strong>{{ $t('general.premium') }}</strong>
  </small>
  <ws-tooltip>{{ $t('general.premium_tooltip') }}</ws-tooltip>
</strong>
